// Core React Imports
import React from "react";

// Local Imports
import ConstantsImages from "../../../../constants/ConstantsImages";
import WidgetIconFive from "../../../icons/widget-icon-five/WidgetIconFive";
import "./WidgetCustomFooterItemFirst.css";

const WidgetCustomFooterItemFirst = ({ text }) => {
  return (
    <div className="custom-footer-item-first">
      <WidgetIconFive iconProp={ConstantsImages.PLUS_BLUE_IMAGE} widthIconProp="1.5rem" heightIconProp="1.5rem" /> {/* 1.4rem 1.5rem */}
      <div className="custom-footer-text-first">{text}</div>
    </div>
  );
};

export default WidgetCustomFooterItemFirst;
